import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { SettingsActionCreators } from "../../redux/action-creators";
import classNames from "classnames";
import { SVGIcon2 } from "../common/SVGIconV2";

const SettingsPCHeaderItem = ({ trackingInfo }) => {
  const dispatch = useDispatch();

  const componentTrackingInfo = useMemo(
    () =>
      Object.assign(
        {
          dataCategory: "default",
          dataAction: "click"
        },
        trackingInfo,
        { dataLabel: "uc-settings-pc-open" }
      ),
    [trackingInfo]
  );

  const onClick = useCallback(() => {
    dispatch(SettingsActionCreators.general.toggleDrawer());
  }, [dispatch]);

  const classes = classNames("gearBtn", "circleIcon", "ignore-uc-settings-pc");

  return (
    <a
      className={classes}
      data-testid="uc-settings-pc"
      onClick={onClick}
      data-category={componentTrackingInfo.dataCategory}
      data-action={componentTrackingInfo.dataAction}
      data-label={componentTrackingInfo.dataLabel}
      data-value=""
    >
      <SVGIcon2 iconName="gear" />
    </a>
  );
};

SettingsPCHeaderItem.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(SettingsPCHeaderItem);
